import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import {
  fetchPublicMyHomeV1GetFlatNumberSuggest,
  IPublicMyHomeV1GetFlatNumberSuggestResponse200 as INumberSuggestRes200,
  IPublicMyHomeV1GetFlatNumberSuggestResponse400 as INumberSuggestRes400,
} from '../../../common/repositories/price-estimator/my-home/v1/get-flat-number-suggest';

import { selectFormFields } from 'shared/mf-my-home/selectors';
import { setArea, setFlatAreasSuccessResponse, setFlatNumberSuccessResponse, setRooms } from '../../slices';

export const getFlatNumberSuggest = createAsyncThunk<void, string, IThunkApi>(
  'getFlatNumberSuggest',
  async (flatNumber, _thunkApi) => {
    const {
      extra: { logger, httpApi },
      dispatch,
      getState,
    } = _thunkApi;
    const { houseId } = selectFormFields(getState());

    return fetchPublicMyHomeV1GetFlatNumberSuggest<INumberSuggestRes200, INumberSuggestRes400>({
      httpApi,
      parameters: {
        houseId: houseId as number,
        flatNumber,
      },
    })
      .then(response => {
        if (response.statusCode === 200) {
          const { area, roomsCount } = response.response;

          if (area) {
            // Если данные есть
            dispatch(setArea(area)); //Устанавливаем колличество комнат
            dispatch(setRooms(roomsCount)); // Если данные есть - заполняем/Если нет - отчищаем
            dispatch(setFlatAreasSuccessResponse({ flatAreas: undefined })); // Отчищаем данные о комнатности из стора
          } else {
            // Кейс на случай чейджа инпута - если по одной квартире были а по другой нет
            dispatch(setArea(area)); // Отчищаем поле
            dispatch(setRooms(roomsCount)); // Отчищаем поле
          }
        }

        return Promise.reject(response);
      })
      .catch(response => {
        logger.error(response);
      })
      .finally(() => dispatch(setFlatNumberSuccessResponse(true)));
  },
);
